
































































import { Component, Mixins, Ref } from "vue-property-decorator"
import PageHeader from "@/components/page-header/index.vue"
import policyService from "@/services/policy.service"
import PageMixin from "@/mixins/page"
import { getColumns } from "./constant"
import { mapGetters } from "vuex"
import { FormModel } from "ant-design-vue"
import commonService from "@/services/common.service"
import { omit } from "lodash"
import AddOrEditModel from "./addOrEditModel.vue"
@Component({
    components: {
        PageHeader,
        AddOrEditModel
    },
    computed: {
        ...mapGetters(["currentUser"]),
        ...mapGetters("common", ["area", "textTypeMap"])
    }
})
export default class PolicyTextConfig extends Mixins(PageMixin) {
    readonly currentUser: any
    readonly area: any
    readonly textTypeMap: any
    value = ""
    searchValue = ""
    selectData: any = []
    loading = false
    dataSource: any = []
    userRoles: { system_roles: any[] } = { system_roles: [] }

    showEditModal: {
        visible: boolean
        record: any
        list: any[]
        updateText: { id: number; name: ""; en_name: "" }
    } = {
        visible: false,
        record: {} as any,
        list: [{ id: 0, name: "", en_name: "", textTips: false, en_textTips: false }],
        updateText: { id: 0, name: "", en_name: "" }
    }

    pagination = {
        current: 1,
        pageSize: 10,
        showQuickJumper: true,
        showSizeChanger: true,
        showLessItems: true,
        size: "normal",
        total: 0,
        pageSizeOptions: ["10", "20", "30", "40", "100"],
        showTotal: (total: number) => `共${total}项`
    }

    get vPaginationBinds() {
        const exclude = ["showTotal"]
        return omit(this.pagination, exclude)
    }
    textVisible = false
    markModel = "add"

    @Ref("privacyTextForm")
    refFrom: FormModel

    // 非管理员不展示操作按钮即编辑和启用状态
    get columns() {
        const cols: any = [
            {
                title: "启用状态",
                dataIndex: "status",
                width: 100,
                scopedSlots: { customRender: "status" }
            }
        ]
        if (this.userRoles.system_roles.includes("admin")) {
            return [...getColumns, ...cols]
        } else {
            return [...getColumns]
        }
    }

    get tableActions() {
        return () => {
            if (this.userRoles.system_roles.includes("admin")) {
                const actions = [
                    {
                        title: "编辑",
                        event: "edit"
                    }
                ]
                return actions
            } else {
                return []
            }
        }
    }

    created() {
        this.getList()
        this.getUserRoles()
    }
    isAdmin = false
    async getUserRoles() {
        try {
            const res = await commonService.getUserRoles({
                user_id: this.currentUser.uid
            })
            this.userRoles = res || {}
            this.isAdmin = this.userRoles.system_roles.includes("admin")
        } catch (error) {
            this.$message.error(`获取权限失败！${error}`)
        }
    }

    async handleAddOrEdit() {
        this.markModel = "add"
        this.showEditModal.visible = true
    }

    onEdit(records: any[]) {
        const record = records[0]
        this.markModel = "edit"
        this.showEditModal.updateText.name = record.name
        this.showEditModal.updateText.en_name = record.en_name
        this.showEditModal.updateText.id = record.id
        this.showEditModal.visible = true
    }

    onInputSearch() {
        this.getList()
    }

    // 修复分页事件处理
    handlePageChange(page: number, pageSize: number) {
        this.pagination.current = page
        this.pagination.pageSize = pageSize
        this.getList()
    }

    handleShowSizeChange(current: number, size: number) {
        this.pagination.pageSize = size
        this.pagination.current = 1
        this.getList()
    }
    onChangeSwitch(checked: any) {
        // 1 启用，2 禁用
        this.textVisible = true
        const text = checked.status == 1 ? "禁用" : "启用"
        this.$confirm({
            title: `${text}文本类型`,
            content: `您是否确认${text}该文本类型`,
            okText: "确认",
            cancelText: "取消",
            icon: (h: any) => {
                return h("a-icon", {
                    props: {
                        type: "exclamation-circle",
                        style: "background: yellow"
                    }
                })
            },
            async onOk() {
                checked.status = checked.status == 1 ? 2 : 1
                const payload = { id: checked.id, status: checked.status }
                await policyService.textTypeEnableOrDisable(payload)
            }
        })
    }

    async getList() {
        const offset = (this.pagination.current - 1) * this.pagination.pageSize
        const limit = this.pagination.pageSize
        const payload: any = {
            offset,
            limit,
            name: this.searchValue
        }
        this.loading = true
        try {
            const res = await policyService.getTextTypeList(payload)
            const { total, list } = res
            this.dataSource = list || []
            this.pagination.total = total
        } catch (error) {
            if (error) {
                this.$message.error(`获取数据失败！ ${error}`)
            }
        } finally {
            this.loading = false
        }
    }
}
